
import { Bike } from '../types';

export const mockBikes: Bike[] = Array(20).fill(null).map((_, i) => {
  // Генерируем случайные данные для велосипедов
  const isInUse = Math.random() > 0.6;
  const isRetired = Math.random() > 0.9; // 10% шанс что велосипед списан
  const status: Bike['status'] = isRetired ? 'retired' : (isInUse ? 'in_use' : ['available', 'maintenance'][Math.floor(Math.random() * 2)] as Bike['status']);
  
  // Добавляем информацию о курьере, если велосипед используется
  const courierName = isInUse && !isRetired ? 
    ['Иванов А.', 'Петров С.', 'Сидоров И.', 'Козлов Д.', 'Смирнов П.'][Math.floor(Math.random() * 5)] : 
    null;
  
  return {
    id: `bike-${i + 1}`,
    serialNumber: `SN-${Math.floor(100000 + Math.random() * 900000)}`,
    model: ['City Cruiser', 'Mountain Explorer', 'Urban Commuter', 'Delivery Pro'][Math.floor(Math.random() * 4)],
    mileage: String(Math.floor(Math.random() * 5000)), // Конвертируем в строку
    status,
    lastMaintenance: new Date(Date.now() - Math.floor(Math.random() * 90) * 24 * 60 * 60 * 1000).toISOString(),
    gps_tag: undefined,
    courierName,
    ...(isInUse && !isRetired ? {
      currentRental: {
        id: `rental-${i}`,
        courierId: `courier-${i}`,
        courierName: courierName || '',
        startDate: new Date(Date.now() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000).toISOString(),
      }
    } : {})
  };
});
